import { useMemo } from 'react';
import { IShopPreviewProps } from '~/components/ui/ShopPreview';
import { IVehicleTuningShopItem, rage, useObservable } from '~/rage';
import { WalletType } from '~/shared';
import {
	getWheelSettingsTotalPrice,
	isDefaultValues,
} from '../components/WheelSettingsTab';
import { useLayoutSelector } from '../redux';
import { useBuy } from './useBuy';
import { getEffectiveTuningSelection } from '../utils/resolveTuningShopVariant';

const useShopPreview = (): IShopPreviewProps => {
	const activeStage = useLayoutSelector((state) => state.tuning.activeStage);
	const activeList = useLayoutSelector((state) => state.tuning.activeList);
	const activeListIndex = useLayoutSelector(
		(state) => state.tuning.activeListIndex,
	);
	const activeVariants = useLayoutSelector(
		(state) => state.tuning.activeVariants,
	);
	const ownedWheelsSettings = useObservable(
		rage.vehicleTuningShop.getOwnedWheelsSettings(),
	);
	const wheelSettings = useLayoutSelector(
		(state) => state.tuning.wheelSettings,
	);
	const wheelsSetupPrice = useObservable(
		rage.vehicleTuningShop.getWheelsSetupPrice(),
	);

	const { handleBuy } = useBuy();

	const totalWheelPrice = useMemo(
		() =>
			ownedWheelsSettings
				? getWheelSettingsTotalPrice(
						wheelSettings,
						wheelsSetupPrice,
						ownedWheelsSettings,
				  )
				: 0,
		[wheelSettings, wheelsSetupPrice, ownedWheelsSettings],
	);

	const visible = useMemo(
		() => activeStage !== 'category' && activeListIndex !== null,
		[activeStage, activeListIndex],
	);

	const item = useMemo<IVehicleTuningShopItem | undefined>(
		() => activeList[activeListIndex || 0],
		[activeList, activeListIndex],
	);

	const effective = useMemo(
		() => getEffectiveTuningSelection(item, activeVariants),
		[item, activeVariants],
	);

	if (activeStage === 'wheel_settings') {
		return {
			visible: ownedWheelsSettings
				? !isDefaultValues(wheelSettings, ownedWheelsSettings)
				: false,
			name: 'Настройка колёс',
			price: totalWheelPrice,
			handlePayByCash: () => handleBuy(WalletType.Cash),
			handlePayByCard: () => handleBuy(WalletType.Bank),
		};
	}

	return {
		visible: visible && !effective.isInstalled,
		name: effective.installLabel,
		price: effective.price,
		handlePayByCash: () => handleBuy(WalletType.Cash),
		handlePayByCard: () => handleBuy(WalletType.Bank),
	};
};

export { useShopPreview };
